export default __webpack_public_path__ + "static/InterDisplay-ExtraLight-12a32f64ba176ac4212648571e6175a4.woff2";